
export const ATTRS_VALUE_TYPES_TRANSLATE: any[] = [
    {
        id: 'INTEGER',
        translate: 'Целочисленный'
    },
    {
        id: 'NUMERIC',
        translate: 'Числовой'
    },
    {
        id: 'STRING',
        translate: 'Строковый'
    },
    {
        id: 'DATE',
        translate: 'Дата'
    },
    {
        id: 'DATETIME',
        translate: 'Дата и время'
    },
    {
        id: 'BOOLEAN',
        translate: 'Логический'
    },
    // {
    //     id: 'TIMESTAMP',
    //     translate: 'Дата и время(Данные хранятся в виде количества секунд, прошедших с начала «эпохи Юникса»)'
    // }
]

export const ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE: any[] = [
    {
        id: 'INPUT',
        translate: 'Однострочное поле для ввода данных'
    },
    {
        id: 'TEXTAREA',
        translate: 'Область, с многострочным вводом данных'
    },
    {
        id: 'COMBOBOX',
        translate: 'Список, с выбором одного элемента справочника'
    },
    {
        id: 'COMBOBOX_MULTIPLE',
        translate: 'Список, с множественным выбором элементов справочника'
    },
    {
        id: 'FILE',
        translate: 'Файл'
    },
    {
        id: 'FILE_MULTIPLE',
        translate: 'Множественная загрузка файла'
    },
    {
        id: 'CERTIFICATE',
        translate: 'Сертификат'
    },
    {
        id: 'TAGS',
        translate: 'ТЭГ'
    },
    {
        id: 'DATE',
        translate: 'Дата'
    },
    // {
    //     id: 'CHECKBOX',
    //     translate: 'Поле с выбором Да/Нет(Галочка)'
    // },
    // {
    //     id: 'LIST',
    //     translate: 'Пользовательское поле отображающее список данных'
    // },
    // {
    //     id: 'COMBOBOX_GROUP_MULTIPLE',
    //     translate: 'Пользовательское поле отображающее список данных с множественным выбором и возможностью группировки'
    // },
    // {
    //     id: 'COMBOBOX_GROUP',
    //     translate: 'Пользовательское поле отображающее список данных и возможностью группировки'
    // },
    // {
    //     id: 'COMBOBOX_FILTER',
    //     translate: 'Пользовательское поле отображающее список данных с множественным выбором и возможностью фильтрации'
    // },

    // {
    //     id: 'DATETIME',
    //     translate: 'Дата и время'
    // },

]